import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Page from '@/pages'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isPasswordInit) {
      next('/change/password')
    } else {
      next('/admin/main')
    }
    return
  }
  next()
}

const ifNotAuthenticatedUser = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isPasswordInit) {
      next('/change/password')
    } else {
      next('/user/main')
    }
    return
  }
  next()
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isPasswordInit) {
      next('/change/password')
      return
    }
    // 로그인 사용자가 학생일 경우 /admin 경로로 접근하는것을 막고 사용자 메인 페이지로 이동시킨다.
    if (to.path.indexOf('/admin') !== -1 && store.getters.user_type === 'S') {
      next('/user/main')
    } else {
      next()
    }
    return
  }
  next('/admin/login')
}

const ifUserAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isPasswordInit) {
      next('/change/password')
    } else {
      next()
    }
    return
  }
  if (to.path) {
    next({path: '/user/login', query: {q: to.path}})
  } else {
    next('/user/login')
  }
}

const ifPasswordAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next('/admin/login')
    return
  }
  next()
}

const router = new Router({
  // mode: 'hash',
  // base: '/',
  routes: [
    { path: '/', redirect: {name: 'LOGIN_A'} },
    { path: '/admin/login', name: 'LOGIN_A', component: Page.LoginAdmin, beforeEnter: ifNotAuthenticated },
    { path: '/teacher/login', name: 'LOGIN_T', component: Page.LoginTeacher, beforeEnter: ifNotAuthenticated },
    { path: '/user/login', name: 'LOGIN_S', component: Page.LoginUser, beforeEnter: ifNotAuthenticatedUser },
    { path: '/user/agreement', name: 'AGREEMENT', component: Page.Agreement, beforeEnter: ifNotAuthenticatedUser }, // 가입약관
    { path: '/user/join', name: 'JOIN', component: Page.Join, beforeEnter: ifNotAuthenticatedUser }, // 회원가입요청
    { path: '/user/signup', name: 'SIGN_UP', component: Page.SignUp, beforeEnter: ifNotAuthenticatedUser }, // 회원가입
    { path: '/logout', name: 'LOGOUT', component: Page.Logout },
    { path: '/change/password', name: 'CHANGE_PASSWORD', component: Page.ChangePassword, beforeEnter: ifPasswordAuthenticated },
    { path: '/change/password/:init_yn', name: 'USER_CHANGE_PASSWORD', component: Page.ChangePassword, beforeEnter: ifPasswordAuthenticated },
    { path: '/admin',
      component: Page.Admin,
      beforeEnter: ifAuthenticated,
      children: [
        { path: '', redirect: {name: 'LOGIN_A'} }, // 로그인 화면
        { path: 'main', name: 'MAIN_A', component: Page.Main, meta: {page: '', parent_page: ''} }, // 메인 화면
        { path: 'main', name: 'MAIN_T', component: Page.Main, meta: {page: '', parent_page: ''} }, // 메인 화면
        { path: 'M010101', name: 'M010101', component: Page.M010101, meta: {page: 'M01', parent_page: ''} }, // 교재관리
        { path: 'M020101', name: 'M020101', component: Page.M020101, meta: {page: 'M02', parent_page: ''} }, // 수강관리
        { path: 'M020102', name: 'M020102', component: Page.M020102, meta: {page: 'M02', parent_page: ''} }, // 클래스등록
        { path: 'M020103/:class_seq', name: 'M020103', component: Page.M020103, meta: {page: 'M02', parent_page: ''} }, // 클래스수강생등록
        { path: 'M020104/:class_seq', name: 'M020104', component: Page.M020104, meta: {page: 'M02', parent_page: ''} }, // 출석체크
        { path: 'M020105/:class_seq', name: 'M020105', component: Page.M020105, meta: {page: 'M02', parent_page: ''} }, // 출석설정
        { path: 'M020106/:class_seq', name: 'M020106', component: Page.M020106, meta: {page: 'M02', parent_page: ''} }, // 출석체크(수정)
        { path: 'M030101', name: 'M030101', component: Page.M030101, meta: {page: 'M03', parent_page: ''} }, // 문제관리
        { path: 'M030102/:quiz_seq', name: 'M030102', component: Page.M030102, meta: {page: 'M03', parent_page: ''} }, // 문제상세
        { path: 'M030103', name: 'M030103', component: Page.M030103, meta: {page: 'M03', parent_page: ''} }, // 문제관리(수정)
        { path: 'M040101', name: 'M040101', component: Page.M040101, meta: {page: 'M04', parent_page: ''} }, // 시험지관리
        { path: 'M040102/:exam_paper_seq', name: 'M040102', component: Page.M040102, meta: {page: 'M04', parent_page: ''} }, // 시험지상세
        { path: 'M050101', name: 'M050101', component: Page.M050101, meta: {page: 'M0501', parent_page: 'M05'} }, // 시험관리
        { path: 'M050102', name: 'M050102', component: Page.M050102, meta: {page: 'M0501', parent_page: 'M05'} }, // 시험등록
        { path: 'M050103/:exam_seq', name: 'M050103', component: Page.M050103, meta: {page: 'M0501', parent_page: 'M05'} }, // 시험상세
        { path: 'M050201', name: 'M050201', component: Page.M050201, meta: {page: 'M0502', parent_page: 'M05'} }, // 오답노트
        { path: 'M050202/:exam_seq', name: 'M050202', component: Page.M050202, meta: {page: 'M0502', parent_page: 'M05'} }, // 오답노트 상세
        { path: 'M060101', name: 'M060101', component: Page.M060101, meta: {page: 'M0601', parent_page: 'M06'} }, // 시험별성적표
        { path: 'M060102/:exam_seq', name: 'M060102', component: Page.M060102, meta: {page: 'M0601', parent_page: 'M06'} }, // 시험별성적상세
        { path: 'M060103/:exam_seq/:class_seq/:class_user_seq', name: 'M060103', component: Page.M060103, meta: {page: 'M0601', parent_page: 'M06'} }, // 성적관리사용자상세(성적표)
        { path: 'M060201', name: 'M060201', component: Page.M060201, meta: {page: 'M0602', parent_page: 'M06'} }, // 수강반별성적표
        { path: 'M060202/:class_seq', name: 'M060202', component: Page.M060202, meta: {page: 'M0602', parent_page: 'M06'} }, // 수강반별성적표 상세
        { path: 'M060301', name: 'M060301', component: Page.M060301, meta: {page: 'M0603', parent_page: 'M06'} }, // 회독성적표
        { path: 'M060302/:class_seq', name: 'M060302', component: Page.M060302, meta: {page: 'M0603', parent_page: 'M06'} }, // 회독성적표 대상
        { path: 'M060303/:book_seq/:class_seq/:class_user_seq', name: 'M060303', component: Page.M060303, meta: {page: 'M0603', parent_page: 'M06'} }, // 회독성적표 상세
        { path: 'M060401', name: 'M060401', component: Page.M060401, meta: {page: 'M0604', parent_page: 'M06'} }, // 종합성적표
        { path: 'M060402/:class_seq', name: 'M060402', component: Page.M060402, meta: {page: 'M0604', parent_page: 'M06'} }, // 종합성적표 대상
        { path: 'M060403/:class_seq', name: 'M060403', component: Page.M060403, meta: {page: 'M0604', parent_page: 'M06'} }, // 종합성적표 대상_2
        { path: 'M070101', name: 'M070101', component: Page.M070101, meta: {page: 'M0701', parent_page: 'M07'} }, // 성적분포
        { path: 'M070102/:exam_seq', name: 'M070102', component: Page.M070102, meta: {page: 'M0701', parent_page: 'M07'} }, // 성적분포 상세
        { path: 'M070201', name: 'M070201', component: Page.M070201, meta: {page: 'M0702', parent_page: 'M07'} }, // 문제별 상세분석
        { path: 'M070202/:exam_seq', name: 'M070202', component: Page.M070202, meta: {page: 'M0702', parent_page: 'M07'} }, // 문제별 상세분석-상세
        { path: 'M080101', name: 'M080101', component: Page.M080101, meta: {page: 'M08', parent_page: ''} }, // 수강생관리
        { path: 'M080102', name: 'M080102', component: Page.M080102, meta: {page: 'M08', parent_page: ''} }, // 수강생등록
        { path: 'M080103/:user_info_seq', name: 'M080103', component: Page.M080103, meta: {page: 'M08', parent_page: ''} }, // 수강생상세
        { path: 'M080104/:user_info_seq', name: 'M080104', component: Page.M080104, meta: {page: 'M08', parent_page: ''} }, // 수강생시험이력
        { path: 'M990101', name: 'M990101', component: Page.M990101, meta: {page: 'M9901', parent_page: 'M99'} }, // 메뉴관리
        { path: 'M990102/:menu_code', name: 'M990102', component: Page.M990102, meta: {page: 'M9901', parent_page: 'M99'} }, // 메뉴상세
        { path: 'M990201', name: 'M990201', component: Page.M990201, meta: {page: 'M9902', parent_page: 'M99'} }, // 사용자관리
        { path: 'M990202', name: 'M990202', component: Page.M990202, meta: {page: 'M9902', parent_page: 'M99'} }, // 사용자등록
        { path: 'M990203/:user_info_seq', name: 'M990203', component: Page.M990203, meta: {page: 'M9902', parent_page: 'M99'} }, // 사용자상세
        { path: 'M990301', name: 'M990301', component: Page.M990301, meta: {page: 'M9903', parent_page: 'M99'} }, // 권한관리
        { path: 'M990401', name: 'M990401', component: Page.M990401, meta: {page: 'M9904', parent_page: 'M99'} }, // 카테고리
        { path: 'M990402/:cate_code', name: 'M990402', component: Page.M990402, meta: {page: 'M9904', parent_page: 'M99'} }, // 카테고리상세
        { path: 'M990501', name: 'M990501', component: Page.M990501, meta: {page: 'M9905', parent_page: 'M99'} }, // 공통코드
        { path: 'M990502/:code_id/:parent_code', name: 'M990502', component: Page.M990502, meta: {page: 'M9905', parent_page: 'M99'} }, // 공통코드상세
        { path: 'M990601', name: 'M990601', component: Page.M990601, meta: {page: 'M9906', parent_page: 'M99'} }, // 공지사항
        { path: 'M990602/:board_seq', name: 'M990602', component: Page.M990602, meta: {page: 'M9906', parent_page: 'M99'} }, // 공지사항상세
        { path: 'M990701', name: 'M990701', component: Page.M990701, meta: {page: 'M9907', parent_page: 'M99'} }, // 카카오 알림톡 템플릿 관리
        { path: 'M990702', name: 'M990702', component: Page.M990702, meta: {page: 'M990702', parent_page: 'M99'} }, // 카카오 알림톡 발신번호 관리
        { path: 'M990801', name: 'M990801', component: Page.M990801, meta: {page: 'M990801', parent_page: 'M99'} }, // 카카오 알림톡 전송 내역
        { path: 'M991001', name: 'M991001', component: Page.M991001, meta: {page: 'M9910', parent_page: 'M99'} }, // 회원가입 승인
        { path: 'blank', name: 'BLANK_PAGE', component: Page.BlankPage }
      ]
    },
    { path: '/user',
      component: Page.User,
      beforeEnter: ifUserAuthenticated,
      children: [
        { path: '', redirect: {name: 'LOGIN_S'} }, // 로그인 화면
        { path: 'main', name: 'MAIN_S', component: Page.S010201, meta: {page: 'MAIN_S', parent_page: ''} }, // 메인 화면 (시험 성적)
        { path: 'S010101', name: 'S010101', component: Page.S010101, meta: {page: 'S010101', parent_page: ''} }, // 시험보기
        // { path: 'S010102/:exam_seq/:class_seq', name: 'S010102', component: Page.S010102 }, // 시험답안지 작성
        { path: 'S010201', name: 'S010201', component: Page.S010201, meta: {page: 'S010201', parent_page: ''} }, // 시험성적
        { path: 'S010202', name: 'S010202', component: Page.S010202, meta: {page: 'S010202', parent_page: ''} }, // 종합성적표
        { path: 'R010201/:exam_seq/:class_seq/:class_user_seq', name: 'SR010201', component: Page.R010201 }, // 성적표(채점표/개인)
        { path: 'R010203/:exam_seq/:class_seq/:class_user_seq', name: 'SR010203', component: Page.R010203 }, // 성적표(종합)
        { path: 'S010301', name: 'S010301', component: Page.S010301, meta: {page: 'S010301', parent_page: ''} }, // 공지사항
        { path: 'S010401', name: 'S010401', component: Page.S010401, meta: {page: 'S010401', parent_page: ''} }, // 온라인시험참여
        { path: 'S990101', name: 'S990101', component: Page.S990101, meta: {page: 'S990101', parent_page: ''} }, // 마이페이지
        { path: 'S990102', name: 'S990102', component: Page.S990102, meta: {page: 'S990102', parent_page: ''} }, // 회원탈퇴
        { path: 'blank', name: 'S_BLANK_PAGE', component: Page.BlankPage }
      ]
    },
    { path: '/user/S010102/:exam_seq/:class_seq', name: 'S010102', component: Page.S010102, beforeEnter: ifUserAuthenticated }, // 시험답안지작성
    { path: '/report/user/:url', name: 'R000000', component: Page.R000000 },
    { path: '/report/times/:url', name: 'R000001', component: Page.R000001 },
    { path: '/report/R010101/:exam_seq/:class_seq/:class_user_seq', name: 'R010101', component: Page.R010101 }, // 채점표
    { path: '/report/R010201/:exam_seq/:class_seq/:class_user_seq', name: 'R010201', component: Page.R010201 }, // 성적표(채점표/개인)
    { path: '/report/R010203/:exam_seq/:class_seq/:class_user_seq', name: 'R010203', component: Page.R010203 }, // 성적표(종합)
    { path: '/report/R010301/:book_seq/:class_seq/:class_user_seq', name: 'R010301', component: Page.R010301 }, // 회독성적표
    { path: '/error', name: 'PAGE_NOT_FOUND', component: Page.PageNotFound },
    { path: '*', name: 'PAGE_NOT_FOUND_ALL', component: Page.PageNotFound }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js